import React, { useEffect, useRef, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import "./AccountChart.css";
import { useLanguage } from "../../../../Providers/LanguageContext";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  reset_balance_dashboard2,
  reset_current_total_bar2,
  reset_current_total_line2,
  reset_current_vs_actual_budget_bar2,
  reset_current_vs_actual_budget_line2,
  reset_expense_bar_chart,
  reset_expense_bar_chart2,
  reset_expense_line_chart,
  reset_expense_line_chart2,
  reset_expense_per_bar_graph,
  reset_expense_per_bar_graph2,
  reset_expense_per_line_graph,
  reset_expense_per_line_graph2,
  reset_expense_per_line_graph3,
  reset_kanban_data,
  reset_kanban_data2,
  reset_open_acc_receive,
  reset_open_acc_receive2,
  reset_profit_line_chart,
  reset_profit_line_chart2,
  reset_sales_line_chart,
  reset_sales_line_chart2,
  reset_task_at_risk2,
  reset_task_complete_status2,
  reset_task_deviation_analysis2,
  reset_tax_line2,
  reset_tax_pie2,
  reset_transaction_dashboard2,
  set_balance_dashboard2,
  set_current_total_bar2,
  set_current_total_line2,
  set_current_vs_actual_budget_bar2,
  set_current_vs_actual_budget_line2,
  set_expense_bar_chart,
  set_expense_bar_chart2,
  set_expense_line_chart,
  set_expense_line_chart2,
  set_expense_per_bar_graph,
  set_expense_per_bar_graph2,
  set_expense_per_line_graph,
  set_expense_per_line_graph2,
  set_open_acc_receive,
  set_open_acc_receive2,
  set_profit_line_chart,
  set_profit_line_chart2,
  set_sales_line_chart,
  set_sales_line_chart2,
  set_task_at_risk2,
  set_task_complete_status2,
  set_task_deviation_analysis2,
  set_tax_line2,
  set_tax_pie2,
  set_transaction_dashboard2,
  toggle_Kanban_data,
  toggle_Kanban_data2,
} from "../../../../redux/reducers/favDashboardSlice";
import HttpClient from "../../../../utils/HttpClient";
import DashboardManager2 from "../../dashboard/DashboardManager2";
import GanttChart from "../../../TaskManager/GanttChart";
import EventsCalender from "../../../TaskManager/EventsCalender";
import ViewCapitalOption from "../../../InvestmentManager/UserInvestor/ViewCapitalOption";
import RiskManagement from "../../../TaskManager/RiskManagement";
import { useUserData } from "../../../../Providers/UserWrapper";
import Loader from "../../../../Loader/Loader";
import { useSelector } from "react-redux";
import RiskManagement2 from "../../../TaskManager/RiskManagement2";

const AccountChart = () => {
  const { taskCompletionStatus2, taskAtRisk2, taskDeviationAnalysis2 } =
    useSelector((state) => state?.favDashboard);
  const { setIsLoading } = useUserData();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { language } = useLanguage();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [widgetsTwo, setWidgetsTwo] = useState([]);

  // Create a ref for the component
  const componentRef = useRef(null);

  const fetchWidgetOneData = async () => {
    try {
      setIsLoading(true);
      const res = await HttpClient.requestData("dashboard", "GET");
      if (res && res?.widgets && Object.keys(res?.widgets)?.length > 0) {
        setWidgetsTwo(res?.widgets?.two || []);
      } else {
        console.log("error", res);
        setWidgetsTwo([]);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchWidgetOneData();
  }, []);

  const [selectedWidgetOne, setSelectedWidgetOne] = useState(null);

  useEffect(() => {
    if (widgetsTwo) {
      setSelectedWidgetOne(widgetsTwo?.find((item) => item?.visible) || null);
    }
  }, [widgetsTwo]);

  const handleSelectWidget = (widget) => {
    setSelectedWidgetOne(widget);
    toast.success("Widget has been changed successfully");
    closeModal();
    // Scroll to component after a short delay to allow state update
    setTimeout(() => {
      scrollToComponent();
    }, 100);
  };

  useEffect(() => {
    if (selectedWidgetOne) {
      // Reset all first
      dispatch(reset_kanban_data2());
      dispatch(reset_open_acc_receive2());
      dispatch(reset_expense_per_line_graph2());
      dispatch(reset_expense_per_bar_graph2());
      dispatch(reset_expense_bar_chart2());
      dispatch(reset_expense_line_chart2());
      dispatch(reset_profit_line_chart2());
      dispatch(reset_sales_line_chart2());
      dispatch(reset_task_complete_status2());
      dispatch(reset_task_deviation_analysis2());
      dispatch(reset_task_at_risk2());
      dispatch(reset_current_total_bar2());
      dispatch(reset_current_total_line2());
      dispatch(reset_current_vs_actual_budget_bar2());
      dispatch(reset_current_vs_actual_budget_line2());
      dispatch(reset_transaction_dashboard2());
      dispatch(reset_balance_dashboard2());
      dispatch(reset_tax_line2());
      dispatch(reset_tax_pie2());

      // Set based on selected widget
      switch (selectedWidgetOne?.name) {
        case "Kanban Board Analytics":
          dispatch(toggle_Kanban_data2());
          break;
        case "Open Account Receivable":
          dispatch(set_open_acc_receive2());
          break;
        case "profit vs expense (line graph)":
          dispatch(set_expense_per_line_graph2());
          break;
        case "profit vs expense (pie graph)":
          dispatch(set_expense_per_bar_graph2());
          break;
        case "Expense Bar Chart":
          dispatch(set_expense_bar_chart2());
          break;
        case "Expense Line Chart":
          dispatch(set_expense_line_chart2());
          break;
        case "Profit Line Chart":
          dispatch(set_profit_line_chart2());
          break;
        case "Sales Line Chart":
          dispatch(set_sales_line_chart2());
          break;

        case "Task Completion Status":
          dispatch(set_task_complete_status2());
          break;
        case "Task Deviation Analysis":
          dispatch(set_task_deviation_analysis2());
          break;
        case "Tasks At-Risk":
          dispatch(set_task_at_risk2());
          break;

        case "current total (bar graph)":
          dispatch(set_current_total_bar2());
          break;
        case "current total (line graph)":
          dispatch(set_current_total_line2());
          break;
        case "current actual vs budget (bar graph)":
          dispatch(set_current_vs_actual_budget_bar2());
          break;
        case "current actual vs budget (line graph)":
          dispatch(set_current_vs_actual_budget_line2());
          break;
        case "Balance dashboard":
          dispatch(set_balance_dashboard2());
          break;
        case "Transaction dashboard":
          dispatch(set_transaction_dashboard2());
          break;
        case "Tax deductible (pie graph)":
          dispatch(set_tax_pie2());
          break;
        case "Tax deductible (line graph)":
          dispatch(set_tax_line2());
          break;
        default:
          break;
      }
    }
  }, [dispatch, selectedWidgetOne]);

  // Function to smoothly scroll to component
  const scrollToComponent = () => {
    if (componentRef.current) {
      const element = componentRef.current;
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 100; // 100px offset from top

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const handleAddWidget = async (widget) => {
    console.log("widget2", widget);
    try {
      const res = await HttpClient.requestData("dashboard", "PUT", {
        widgetId: widget?.widgetId,
      });
      if (res?.message !== "Widget not found in dashboard") {
        toast.success("Widget one has been updated successfully");
        setSelectedWidgetOne(widget);
        fetchWidgetOneData();
        closeModal();
        // Scroll to component after a short delay to allow state update
        setTimeout(() => {
          scrollToComponent();
        }, 100);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!!!");
    }
  };

  const pieData = [
    { name: "Current AR", value: 100 },
    { name: "Past due AR", value: 0 },
  ];

  const COLORS = ["#0D2231", "#CFCFCF"];

  return (
    <>
      <div
        className="account-chart-container chart-div-style"
        ref={componentRef}
      >
        {!selectedWidgetOne && <Loader />}
        <div className="calendar-wrapper-mc">
          <div className="calendar-header-mc">
            <h3 class="chart-title-mc">{selectedWidgetOne?.name?.toUpperCase()}</h3>
            <i
              className="fa-regular fa-pen-to-square edit-icon-mc"
              onClick={openModal}
            ></i>
          </div>
        </div>
        {/* <div className="grand-chart-head">
          <div className="chart-head-left">
            <h3 className="grantt-title">
              {selectedWidgetOne?.name?.toUpperCase() ||
                "Open Account Receivable"?.toUpperCase()}
            </h3>
          </div>

          <div className="chart-head-right">
            <div className="head-right-1 d-none">
              <button className="f-btn">New Features</button>
              <button className="f-btn">Select User</button>
            </div>

            <div className="icons-dc">
              <i
                className="fa-regular fa-pen-to-square icon-dc"
                onClick={openModal}
              ></i>
            </div>
          </div>
        </div> */}

        {/* Conditionally render the original AccountChart content only for Open Account Receivable */}

        {/* Render other widgets based on selection */}
        {selectedWidgetOne?.name === "Gantt Chart" && <GanttChart />}
        {selectedWidgetOne?.name === "Event calender" && <EventsCalender />}
        {selectedWidgetOne?.name === "Investment Manager" && (
          <ViewCapitalOption />
        )}
        {selectedWidgetOne?.name === "Kanban Board Analytics" && (
          <EventsCalender />
        )}
        {selectedWidgetOne?.name === "Open Account Receivable" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name === "Risk Management" && <RiskManagement />}
        {selectedWidgetOne?.name === "profit vs expense (line graph)" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name === "profit vs expense (pie graph)" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name === "Expense Bar Chart" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name === "Expense Line Chart" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name === "Profit Line Chart" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name === "Sales Line Chart" && (
          <DashboardManager2 />
        )}

        {selectedWidgetOne?.name === "Task Completion Status" && (
          <RiskManagement2
            taskCompleteStatus={taskCompletionStatus2}
            taskAtRisk={taskAtRisk2}
            taskDeviationAnalysis={taskDeviationAnalysis2}
          />
        )}
        {selectedWidgetOne?.name === "Task Deviation Analysis" && (
          <RiskManagement2
            taskCompleteStatus={taskCompletionStatus2}
            taskAtRisk={taskAtRisk2}
            taskDeviationAnalysis={taskDeviationAnalysis2}
          />
        )}
        {selectedWidgetOne?.name === "Tasks At-Risk" && (
          <RiskManagement2
            taskCompleteStatus={taskCompletionStatus2}
            taskAtRisk={taskAtRisk2}
            taskDeviationAnalysis={reset_task_deviation_analysis2}
          />
        )}
        {selectedWidgetOne?.name === "current total (bar graph)" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name === "current total (line graph)" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name === "current actual vs budget (bar graph)" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name ===
          "current actual vs budget (line graph)" && <DashboardManager2 />}

        {selectedWidgetOne?.name === "Balance dashboard" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name === "Transaction dashboard" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (pie graph)" && (
          <DashboardManager2 />
        )}
        {selectedWidgetOne?.name === "Tax deductible (line graph)" && (
          <DashboardManager2 />
        )}
      </div>

      {/* MODAL */}
      {isModalOpen && (
        <div className="gd-modal-overlay" onClick={closeModal}>
          <div
            className="gd-modal-panel chart-div-style"
            onClick={(e) => e.stopPropagation()} // prevent overlay close
          >
            <h3 className="gd-modal-title">
              {language?.add_new_dashboard?.toUpperCase()}
            </h3>

            <div className="gd-modal-list">
              {widgetsTwo?.length > 0 ? (
                widgetsTwo?.map((widget) => (
                  <button
                    disabled={widget?.visible}
                    style={{
                      opacity: widget?.visible ? 0.3 : 1,
                      cursor: widget?.visible ? "not-allowed" : "pointer",
                    }}
                    className="gd-modal-row"
                    key={widget?.id}
                    onClick={() => handleAddWidget(widget)}
                  >
                    <span>{widget?.name?.toUpperCase()}</span>
                    <span
                      style={{
                        opacity: widget?.visible ? 0.3 : 1,
                        cursor: widget?.visible ? "not-allowed" : "pointer",
                      }}
                      className="gd-modal-plus-btn"
                    >
                      <i className="fa-solid fa-plus"></i>
                    </span>
                  </button>
                ))
              ) : (
                <div className="gd-modal-row">
                  <span>No Widget Found ...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AccountChart;
